import * as React from 'react';
import { LrNotesDialog } from 'components/LrNotes';
import { postUWReviewDecline } from 'services/uwReview';
import { useSelector } from 'react-redux';
import { getLogTypesByCode } from 'application/redux/selectors';
import { Location } from 'types/location.type';

interface Props {
    submissionId: string;
    quoteId?: string;
    action: any;
    productLineCode?: string;
    declinedLocations?: Location[];
    setAction: (action: any) => void;
    onCancel: () => void;
    onSubmit: () => void;
}

const DeclineReviewDialog: React.FunctionComponent<Props> = (props) => {
    const { action, onCancel, onSubmit, quoteId, setAction, submissionId, productLineCode, declinedLocations } = props;

    // Global State
    const logTypes = useSelector(getLogTypesByCode);

    const submitDecline = async () => {
        setAction({ ...action, inProgress: true });
        try {
            const payload = {} as any;
            if (productLineCode && declinedLocations) {
                payload.declinedLocationsByLineCode = { [productLineCode]: declinedLocations.map((l) => l.id) };
            }
            await postUWReviewDecline(submissionId, payload);
            setAction({ ...action, inProgress: false, success: true });
            onSubmit && onSubmit();
        } catch (err) {
            setAction({
                ...action,
                inProgress: false,
                success: false,
                error: false,
            });
        }
    };

    return (
        <LrNotesDialog
            isOpen
            title="Decline Underwriting"
            content={`Provide a short summary of why the underwriting is being declined for the following location(s): \n ${declinedLocations
                ?.map((l) => l.locationName)
                .join(', ')}`}
            onCancel={onCancel}
            onSubmit={submitDecline}
            options={{
                submissionId: submissionId,
                logTypeId: logTypes.UW_DECLINED.id,
                quoteId: quoteId,
            }}
        />
    );
};

export default DeclineReviewDialog;
